import * as CSS from "csstype"
import { system } from "styled-system"

const textTransform = system({
  textTransform: true,
})

export interface TextTransformProps {
  textTransform?: CSS.Property.TextTransform
}

export default textTransform
